import { Collapse } from 'antd';
import Dropdown from "app/components/shared/app/Dropdown";
import Constants from 'app/lib/Constants';
import { getInnerError, isAccountAdmin } from 'app/lib/utils/adaya/AdayaUtils';
import Button from 'components/shared/app/Button';
import Modal from 'components/shared/app/Modal';
import Spinner from 'components/shared/app/Spinner';
import Config from 'lib/Config';
import AccountService from 'lib/services/AccountService';
import NotificationService from 'lib/services/NotificationService';
import UserService from 'lib/services/UserService';
import { ValidationUtils } from 'lib/utils/Validation';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import AdayaIDIcon from 'static/icons/account/adaya-id.svg';
import DownArrow from 'static/icons/account/down-arrow.svg';
import IntegrationsIcon from 'static/icons/account/integrations.svg';
import ProfileIcon from 'static/icons/account/profile.svg';
import RightArrow from 'static/icons/account/right-arrow.svg';
import UsersIcon from 'static/icons/account/users.svg';
import ProfileForm from './ProfileForm';
import Providers from './Providers';
import './style.scss';
import TrackingCard from './TrackingCard';
const { Panel } = Collapse;

const roles = [
    { value: 'admin', label: 'Admin' },
    { value: 'user', label: 'Analyst' }
];

const Account = (props) => {
    const navigate = useNavigate();
    const [editingPaymentInfo, setEditingPaymentInfo] = useState(false);
    const [showInvitationModal, setShowInvitationModal] = useState(false);
    const [showInvitaionSentModal, setShowInvitationSentModal] = useState(false);
    const [showRemoveUserModal, setShowRemoveUserModal] = useState(false);
    const [invitationRole, setInvitationRole] = useState('user');
    const [invitationEmail, setInvitationEmail] = useState('');
    const [removingUser, setRemovingUser] = useState();
    const [loading, setLoading] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const user = props.auth.user;
    const account = user?.activeAccount;

    useEffect(() => {
        if (!isAccountAdmin(user)) {
            navigate(Constants.DEFAULT_LOGIN_ROUTE);
        }
    }, [user]);

    const onCardSubmit = async (pd) => {
        if (pd.paymentId) {
            await props.auth.updatePaymentMethod(pd.paymentId);
            setEditingPaymentInfo(false);
        }
    };

    const onError = (e) => {
        console.log('error', e);
    };

    const formatTime = (time) => {
        let m = moment.unix(time);
        return m.format('M/D/YYYY');
    };

    const deleteMyAccount = () => {
        if (confirm('Please be certain you want to delete your account. This is not recoverable. Are you sure?')) {
            UserService.deleteAccount(props.auth.user._id)
                .then(() => {
                    window.location.reload();
                });
        }
    }

    const onSendInvitation = async () => {
        if (!ValidationUtils.isEmail(invitationEmail)) {
            return NotificationService.notifyError('Invalid Email', 'Please enter a valid email address');
        }

        if (account.accountUsers) {
            const existing = account.accountUsers.filter(sub => sub.email === invitationEmail).length;
            if (existing) {
                return NotificationService.notifyError('Email Already Invited', `We already sent the invitation to ${invitationEmail}`);
            }
        }

        try {
            setLoading(true);
            const r = await AccountService.sendInvitation(account._id, invitationEmail, invitationRole);
            setShowInvitationModal(false);

            if (r.success) {
                props.auth.updateUserLocal(r.user);
                setShowInvitationSentModal(true);
            } else {
                return NotificationService.notifyError('Error', r.error);
            }
        } catch (e) {
            console.error('error', e);
            setShowInvitationModal(false);
            return NotificationService.notifyError('Error', getInnerError(e));
        }
        setLoading(false);
    };

    const onRemovePendingUser = async () => {
        try {
            setLoading(true);
            const r = await AccountService.removePendingInvitation(account._id, removingUser.email);
            setLoading(false);

            if (r.success) {
                props.auth.updateUserLocal(r.user);
            } else {
                return NotificationService.notifyError('Error', r.error);
            }
        } catch (e) {
            console.error('error', e);
            setShowRemoveUserModal(false);
            return NotificationService.notifyError('Error', getInnerError(e));
        }
        setShowRemoveUserModal(false);
        setLoading(false);
    };

    return (
        <div id="account-page" className="account-content content-layout page-layout">

            <Helmet><title>{Config.SITE_TITLE_PREFIX} - Account</title></Helmet>

            <div className="content-header">
                <h2 className="header-title">Account</h2>
            </div>

            <div className="content-body">

                <Collapse className="account-collapse" expandIcon={({ isActive }) => <img src={isActive ? DownArrow : RightArrow} />}>

                    <Panel header={<PanelHeader icon={ProfileIcon} title="Profile" description="Update your account information and email" />}>
                        <ProfileForm auth={props.auth} />
                    </Panel>

                    {account && isAccountAdmin(user) &&
                        <Panel header={<PanelHeader icon={UsersIcon} title="Users" description="Invite new users and manage existing users" />} >
                            <div className="account-users card-panel">
                                <div className="account-users-row">
                                    <h3>Users</h3>
                                </div>
                                {account.accountUsers &&
                                    <>
                                        {account.accountUsers.filter(sub => sub.accepted).map(sub => (
                                            <div className="account-users-row member">
                                                <div className="email">
                                                    <h6>{sub.email}</h6>
                                                </div>
                                                <div className="role">
                                                    {sub.role === 'admin' ? 'Admin' : 'Analyst'}
                                                </div>
                                            </div>
                                        ))}
                                        {account.accountUsers.filter(sub => !sub.accepted).map(sub => (
                                            <div className="account-users-row member">
                                                <div className="email">
                                                    <h6>{sub.email}</h6>
                                                    <Button className="remove-user" onClick={() => {
                                                        setRemovingUser(sub);
                                                        setShowRemoveUserModal(true);
                                                    }}>Remove User</Button>
                                                </div>
                                                <div className="status">
                                                    Pending
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                }
                                <div className="account-users-row">
                                    <button className="invite-user" onClick={() => setShowInvitationModal(true)}>
                                        Invite New User
                                    </button>
                                </div>
                            </div>
                        </Panel>
                    }

                    <Panel header={<PanelHeader icon={IntegrationsIcon} title="Integrations" description="Connect platforms and manage integrations" />}>
                        <Providers auth={props.auth} />
                    </Panel>

                    <Panel header={<PanelHeader icon={AdayaIDIcon} title="Adaya ID" description="Access your unique Adaya ID tracking code" />}>
                        <TrackingCard {...props} />
                    </Panel>

                </Collapse>

            </div>

            {showInvitationModal &&
                <Modal active={showInvitationModal} toggleActive={() => setShowInvitationModal(false)}>
                    <div className={loading ? 'account-modal loading' : 'account-modal'}>
                        {loading ? <Spinner color="blue" /> : (
                            <>
                                <h5>Invite new user</h5>
                                <div className="form-field">
                                    <h6>EMAIL</h6>
                                    <input className="input" type="email" value={invitationEmail} onInput={e => setInvitationEmail(e.target.value)} />
                                </div>
                                <div className="form-field">
                                    <h6>ROLE</h6>
                                    <Dropdown
                                        selectedItem={roles.find(r => r.value == invitationRole).label}
                                        items={roles}
                                        setSelection={setInvitationRole}
                                    />
                                </div>
                                <div className="actions">
                                    <Button round simple filled center color="green" textPosition="center" onClick={onSendInvitation}>
                                        Invite
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                </Modal>
            }

            {showInvitaionSentModal &&
                <Modal active={showInvitaionSentModal} toggleActive={() => setShowInvitationSentModal(false)}>
                    <div className="account-modal">
                        <h5>Invite sent!</h5>
                        <div className="description">
                            An invitation has been sent to:&nbsp;
                            <b>{invitationEmail}</b>
                        </div>
                        <div className="actions">
                            <Button
                                round simple filled center color="green"
                                textPosition="center"
                                onClick={() => setShowInvitationSentModal(false)}>
                                Close
                            </Button>
                        </div>
                    </div>
                </Modal>
            }

            {showRemoveUserModal &&
                <Modal active={showRemoveUserModal} toggleActive={() => setShowRemoveUserModal(false)}>
                    <div className={loading ? 'account-modal loading' : 'account-modal'}>
                        {loading ? <Spinner color="blue" /> : (
                            <>
                                <h5>Warning</h5>
                                <div className="description">
                                    Once a user is removed they will lose access to your account.
                                    <br /><br />
                                    Are you sure you want to continue?
                                </div>
                                <div className="actions">
                                    <Button
                                        round simple filled center color="green"
                                        textPosition="center"
                                        onClick={onRemovePendingUser}>
                                        Yes
                                    </Button>
                                    <Button
                                        round simple filled center color="green"
                                        textPosition="center"
                                        onClick={() => setShowRemoveUserModal(false)}>
                                        Cancel
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                </Modal>
            }

        </div>
    )
};

const PanelHeader = (props) => {
    const icon = props.icon;
    const title = props.title;
    const description = props.description;

    return (
        <div className="account-panel-header">
            <div className="account-panel-header-left">
                <img src={icon} />
            </div>
            <div className="account-panel-header-right">
                <h5>{title}</h5>
                <p>{description}</p>
            </div>
        </div>
    );
}

export default Account;